const topics = [
  {
    title: '暑期档必看十部高分国产剧',
    desc: '从古装权谋到都市情感，这份片单承包你的整个夏天，每部都值得二刷三刷',
    tag: '编辑精选',
    img: 'https://readdy.ai/api/search-image?query=Summer%20evening%20outdoor%20movie%20screening%20in%20Chinese%20courtyard%2C%20string%20lights%2C%20cozy%20gathering%2C%20warm%20atmosphere%2C%20modern%20Chinese%20lifestyle%2C%20cinematic%20warm%20tones%2C%20soft%20bokeh%20background&width=600&height=400&seq=carousel-1-ql&orientation=landscape',
  },
  {
    title: '2026年最值得期待的华语电影',
    desc: '科幻、悬疑、动作、爱情全覆盖，今年必进影院的大片都在这里了',
    tag: '年度前瞻',
    img: 'https://readdy.ai/api/search-image?query=Modern%20cinema%20interior%20with%20red%20velvet%20seats%20and%20warm%20ambient%20lighting%2C%20empty%20theater%20with%20big%20screen%20glowing%2C%20elegant%20atmosphere%2C%20cinematic%20composition%2C%20professional%20photography&width=600&height=400&seq=carousel-2-ql&orientation=landscape',
  },
  {
    title: 'Netflix 热门韩剧一站式追齐',
    desc: '从《黑暗荣耀》到《鱿鱼游戏2》，热门韩剧合集免费看，字幕精准翻译',
    tag: '海外精选',
    img: 'https://readdy.ai/api/search-image?query=Korean%20drama%20style%20cozy%20living%20room%20with%20large%20TV%20screen%2C%20modern%20minimalist%20interior%2C%20warm%20lighting%2C%20snacks%20on%20coffee%20table%2C%20comfortable%20atmosphere%2C%20evening%20mood%2C%20cinematic%20photography&width=600&height=400&seq=carousel-3-ql&orientation=landscape',
  },
  {
    title: '经典港片修复计划：4K 重温黄金时代',
    desc: '周星驰、成龙、王家卫经典之作高清修复，每一帧都是港片辉煌记忆',
    tag: '经典修复',
    img: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20night%20street%20with%20vibrant%20neon%20signs%2C%20wet%20pavement%20reflections%2C%20iconic%20cityscape%2C%20cinematic%20lighting%2C%20retro%20atmosphere%2C%20warm%20amber%20and%20cyan%20color%20contrast%2C%20noir%20aesthetic&width=600&height=400&seq=carousel-4-ql&orientation=landscape',
  },
  {
    title: '纪录片爱好者必收藏的十部神作',
    desc: '自然、人文、历史、科技，每一部都让你大开眼界，知识量爆炸的观影体验',
    tag: '知识充电',
    img: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20scene%20with%20wild%20animals%20in%20African%20savanna%20at%20golden%20hour%2C%20dramatic%20sunset%20sky%2C%20epic%20landscape%2C%20wildlife%20photography%20style%2C%20warm%20earth%20tones%2C%20professional%20cinematic%20quality&width=600&height=400&seq=carousel-5-ql&orientation=landscape',
  },
  {
    title: '热血动漫全收录：从经典到新番一网打尽',
    desc: '海贼王、进击的巨人、鬼灭之刃全系列高清，日语原声+中文字幕完美体验',
    tag: '动漫专区',
    img: 'https://readdy.ai/api/search-image?query=Colorful%20anime%20style%20cityscape%20with%20vibrant%20sunset%20sky%2C%20illustration%20aesthetic%2C%20dreamy%20clouds%2C%20warm%20golden%20light%2C%20energetic%20composition%2C%20soft%20gradient%20background%2C%20whimsical%20atmosphere&width=600&height=400&seq=carousel-6-ql&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-black text-foreground-900 mb-3">
            精彩专题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            精心策划的影视专题合集，发现你的下一部心头好
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {topics.map((item, idx) => (
            <article
              key={idx}
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300/50 transition-all duration-300 group cursor-pointer flex flex-col"
            >
              <div className="relative overflow-hidden h-44 md:h-52">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-accent-500 text-white text-xs font-medium">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed flex-1 line-clamp-3">
                  {item.desc}
                </p>
                <div className="mt-3 flex items-center gap-1.5 text-primary-500 text-xs md:text-sm font-medium cursor-pointer">
                  <span>查看专题</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}